export const BTC_TX_PLACEHOLDER_VSIZE=79;export const BTC_FIRST_TAPROOT_PATH="m/86'/0'/0'";